export default __webpack_public_path__ + "static/media/moneyPerson.8c6b3e56.svg";